import join from 'url-join';

import { useOptimizely } from '@libs/common-next';

import css from './new.module.scss';

export function New() {
    const { instance } = useOptimizely();

    return (
        <div className={css.add}>
            <p>Add feature flag</p>
            <span>
                Learn
                <a className={css.link} href="https://petsmart.atlassian.net/wiki/x/BwARbg" target="_blank">
                    how to set up
                </a>
                and rollout a new feature flag in the Optimizely dashboard.
            </span>
            <a
                target="_blank"
                href={join(
                    ' https://app.optimizely.com/v2/projects',
                    `${instance?.getProjectConfig()?.projectId}`,
                    'flags/list'
                )}
            >
                Set up
            </a>
        </div>
    );
}
